import { clsx } from "@regrello/core-utils";
import { RegrelloIcon } from "@regrello/ui-core";

export interface PasswordRuleListItemProps {
  /** Whether or not the rule is satisfied. */
  isValid: boolean;

  /** Whether to show an unsatisfied rule in an error state. */
  showInvalidAsError?: boolean;

  /** The text of the rule. */
  text: string;
}

/**
 * A single password rule, consisting of a validation icon and the text for a rule a password must
 * satisfy.
 */
export function PasswordRuleListItem({
  isValid,
  showInvalidAsError: isInvalidShownAsError = false,
  text,
}: PasswordRuleListItemProps) {
  return (
    <div
      className={clsx("flex gap-2 p-1.25", {
        "text-success-textMuted": isValid,
        "text-danger-textMuted": isInvalidShownAsError && !isValid,
      })}
    >
      <RegrelloIcon iconName={isValid ? "selected" : isInvalidShownAsError ? "close" : "blank"} />
      {text}
    </div>
  );
}
